import React from "react";
import 'react-big-calendar/lib/css/react-big-calendar.css';

//styling
import './Calendar.css'

// custom components
import KeyboardBackspaceIcon from "@material-ui/icons/KeyboardBackspace";
import CreditCardIcon from "@mui/icons-material/CreditCard";
import PaymentPopperTransaction from "../../accounting/transactions/PaymentPopperTransaction";
import TopToolbar from "../../global/subcomponents/topToolbar/TopToolbar";
import withShipment from "../../../withShipment";
import ErrorFeedbackBar from "../../global/ErrorFeedbackBar";
import moment from "moment";
import { Checkbox } from '@material-ui/core';
import { TRANSACTION_INVOICE_PAGE_NAME , BACK} from './constants';


class SupplierInvoiceDetail extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            selectedSupplierInvoiceIds: new Set(),
            selectAll: false,
        }

    }

    handleSelectAllChange = (e) => {
        const { clickedDateEvents } = this.props
        const allSupplierInvoiceIds = []

        clickedDateEvents.forEach(event => {
           if (event.data.type === 'Supplier') {
                allSupplierInvoiceIds.push(event.data.supplierInvoiceId)
            }
        });

        if (e.target.checked) {
            this.setState({
               selectedSupplierInvoiceIds: new Set(allSupplierInvoiceIds),
                selectAll: true,
            })
        } else {
            this.setState({
              selectedSupplierInvoiceIds: new Set(),
                selectAll: false,
            })
        }
    }
    

    formatDollar = (amount) => {
        if (amount === null || amount === undefined || amount === '' || isNaN(amount)) {
          return '-'
        }
        return parseFloat(amount)
          .toFixed(2)
          .toString()
          .replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")
    }

    handleCheckboxChange = (event, invoiceId,invoiceType) => {
        const { checked } = event.target;
        const { selectedSupplierInvoiceIds } = this.state;
       const newSelectedSupplierInvoiceIds = new Set(selectedSupplierInvoiceIds);

         if (invoiceType === 'supplier') {
            if (checked) {
                newSelectedSupplierInvoiceIds.add(invoiceId);
            } else {
                newSelectedSupplierInvoiceIds.delete(invoiceId);
            }
        }



        this.setState({
          selectedSupplierInvoiceIds: newSelectedSupplierInvoiceIds
        });
    };


    render() {

        const {clickedDateEvents} = this.props;
        const { selectedSupplierInvoiceIds, selectAll} = this.state;
        const supplierInvoiceIdsArray = Array.from(selectedSupplierInvoiceIds);
        return (
          <>
            <ErrorFeedbackBar />

            { supplierInvoiceIdsArray.length > 0 ? (
              <TopToolbar
                pageName={TRANSACTION_INVOICE_PAGE_NAME}
                menuItems={[
                  {
                    title: BACK,
                    icon: <KeyboardBackspaceIcon />,
                    onClick: () => {
                      this.props.handleBack(false);
                    },
                  },
                  {
                    icon: <CreditCardIcon />,
                    disabled: this.props.bankAccounts.length < 1,
                    title: 'Add Payment Method',
                    popper: (
                      <PaymentPopperTransaction
                        bankAccounts={this.props.bankAccounts}
                        selectedSupplierInvoiceIds={supplierInvoiceIdsArray}
                      />
                    ),
                  },
                ]}
              />
            ) : (
              <TopToolbar
                pageName={TRANSACTION_INVOICE_PAGE_NAME}
                menuItems={[
                  {
                    title: BACK,
                    icon: <KeyboardBackspaceIcon />,
                    onClick: () => {
                      this.props.handleBack(false);
                    },
                  },
                ]}
              />
            )}

            <h4 style={{ margin: '24px' }}>
              Upcoming Payment Due on{' '}
              {moment
                .utc(clickedDateEvents[0]?.data?.dueDate)
                .format('MMMM D, YYYY')}
            </h4>
            <div className="event-table-container">
              <div className="event-table">
                <table>
                  <thead>
                    <tr>
                      <th style={{ paddingRight: '48px', paddingLeft: '24px' }}>
                        <Checkbox
                          type="checkbox"
                          checked={selectAll}
                          onChange={this.handleSelectAllChange}
                          // style={{ width: '16px', height: '16px', accentColor: '#acd685',color: 'white' }}
                        />
                      </th>
                      <th>Due Date</th>
                      <th>Name</th>
                      <th>Invoice Number</th>
                      <th>PO Number</th>
                      <th>Amount Due</th>
                      <th>Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    {clickedDateEvents.map((event, index) => (
                      <tr key={index}>
                        <td
                          style={{ paddingRight: '48px', paddingLeft: '24px',width:'60px'  }}
                        >
                          <Checkbox
                            type="checkbox"
                            checked={
                               selectedSupplierInvoiceIds.has(event.data.supplierInvoiceId)
                            }
                            onChange={(e) =>
                              this.handleCheckboxChange(
                                e,
                                event.data.supplierInvoiceId,
                                event.data.type.toLowerCase()
                              )
                            }
                          />
                        </td>

                        <td>
                          {moment
                            .utc(event.data.dueDate)
                            .format('YYYY-MM-DD')}
                        </td>
                        <td>
                          {event.data.supplierName }
                        </td>
                        <td>{event.data.invoiceNumber}</td>
                        <td>{event.data.poNumber}</td>
                        <td
                          style={{
                              textAlign: "right",
                              padding: "5px",
                              paddingRight: "50px",
                              width: "auto"
                          }}
                        >

                                <div style={{
                                    display: 'flex',
                                    justifyContent: 'flex-start',
                                    alignItems: 'center'
                                }}>
                                    <span style={{flexShrink: 0}}>$</span>
                                    <span style={{
                                        marginLeft: '55px',
                                        minWidth: '80px',
                                        textAlign: 'right'
                                    }}>
                                           {
                                               this.formatDollar(event.data.total == null
                                                 ? event.data.invoiceTotal
                                                 : event.data.total)
                                           }
                         </span>
                                </div>
                        </td>
                        <td
                          style={{
                            color:
                              event.data.status === 'Needs Review'
                                ? 'red'
                                : 'inherit',
                          }}
                        >
                          {event.data.status}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </>
        );
    }
}

const mapStateToProps = (state) => ({
    clickedDateEvents: state.calendar.clickedDateEvents,
});


export default withShipment({
    mapStateToProps,
}, SupplierInvoiceDetail);

